var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutIconOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 910,
    viewBox: "0 0 672 910",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.176,
    y: 528.355,
    width: 520.406,
    height: 520.406,
    rx: 40,
    transform: "rotate(147.703 563.176 528.355)",
    fill: "#025DE8",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.002,
    y: 489.457,
    width: 520.406,
    height: 520.406,
    rx: 40,
    transform: "rotate(147.703 473.002 489.457)",
    fill: "#025DE8",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.834,
    y: 450.564,
    width: 520.406,
    height: 520.406,
    rx: 40,
    transform: "rotate(147.703 382.834 450.564)",
    fill: "#025DE8",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.334,
    y: 436.033,
    width: 520.406,
    height: 520.406,
    rx: 40,
    transform: "rotate(147.703 312.334 436.033)",
    fill: "#025DE8",
    fillOpacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIconOne);
export default __webpack_public_path__ + "static/media/about_icon_one.511df208e00f9ec1d7f41181cccceffb.svg";
export { ForwardRef as ReactComponent };